import { FormFields } from "features/shared/forms/hooks/useForm";
import { assignPhoneInputPrefixDefault } from "features/shared/forms/components/phoneInput/phoneInputConfig";

export const mobilePhoneFormInitValues = (): FormFields | undefined => {
  return assignPhoneInputPrefixDefault({}, "phonePrefix");
};
